import { Util } from '../util';

export namespace Preference {
    export enum _Useless {}

    export namespace Request {
        export interface IFrequentlyAppItem {
            device: Util.Device;
            isDefault: boolean;
            appCodes: string[];
        }
    }

    export namespace Response {}
}
